/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { formatDateWithOrdinal, getChainById, NATIVE, renderToHTML, stringToBlobUrl, useAllo, useParams, useValidateCredential, getMultiplier } from "common";
import React, { createElement, useEffect, useMemo, useState } from "react";
import DefaultLogoImage from "../../assets/default_logo.png";
import { ReactComponent as GithubIcon } from "../../assets/github-logo.svg";
import { ReactComponent as TwitterIcon } from "../../assets/twitter-logo.svg";
import { ReactComponent as GlobeIcon } from "../../assets/icons/globe-icon.svg";
import { ReactComponent as CartCircleIcon } from "../../assets/icons/cart-circle.svg";
import { ReactComponent as CheckedCircleIcon } from "../../assets/icons/checked-circle.svg";
import { ProjectBanner } from "../common/ProjectBanner";
import Breadcrumb from "../common/Breadcrumb";
import { Box, Skeleton, SkeletonText, Tab, Tabs } from "@chakra-ui/react";
import { useDataLayer } from "data-layer";
import { DefaultLayout } from "../common/DefaultLayout";
import { useProject, useProjectApplications } from "./hooks/useProject";
import NotFoundPage from "../common/NotFoundPage";
import { useCartStorage } from "../../store";
import { ProgressStatus } from "../api/types";
import { Input } from "common/src/styles";
import { PayoutTokenDropdown } from "../round/ViewCartPage/PayoutTokenDropdown";
import { useAccount, useSwitchChain } from "wagmi";
import { getVotingTokenOptions } from "../api/utils";
import ErrorModal from "../common/ErrorModal";
import ProgressModal, { errorModalDelayMs } from "../common/ProgressModal";
import { useDirectAllocation } from "./hooks/useDirectAllocation";
import { getAddress, zeroAddress } from "viem";
import GenericModal from "../common/GenericModal";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { BoltIcon } from "@heroicons/react/24/solid";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { getBalance } from "@wagmi/core";
import { config } from "../../app/wagmi";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import { Logger } from "ethers/lib/utils";
import SwitchNetworkModal from "../common/SwitchNetworkModal";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CalendarIcon = props => {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 0C3.44772 0 3 0.447715 3 1V2H2C0.895431 2 0 2.89543 0 4V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2H13V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2H5V1C5 0.447715 4.55228 0 4 0ZM4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H12C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5H4Z",
      fill: "currentColor"
    })
  });
};
export default function ViewProject() {
  const [selectedTab, setSelectedTab] = useState(0);
  const {
    chainId
  } = useAccount();
  const {
    address,
    isConnected
  } = useAccount();
  const {
    openConnectModal
  } = useConnectModal();
  const [showDirectAllocationModal, setShowDirectAllocationModal] = useState(false);
  const [showSwitchNetworkModal, setShowSwitchNetworkModal] = useState(false);
  const [openProgressModal, setOpenProgressModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorModalSubHeading, setErrorModalSubHeading] = useState();
  const [hasNetworkSwitched, setHasNetworkSwitched] = useState(false);
  const [directDonationAmount, setDirectDonationAmount] = useState("");
  const payoutTokenOptions = getVotingTokenOptions(Number(chainId)).filter(p => p.canVote);
  const [payoutToken, setPayoutToken] = useState(payoutTokenOptions[0]);
  const [tokenBalances, setTokenBalances] = useState([]);
  const directAllocationPoolId = getChainById(chainId !== null && chainId !== void 0 ? chainId : 1).contracts.directAllocationPoolId;
  const [transactionReplaced, setTransactionReplaced] = useState(false);
  const {
    projectId
  } = useParams();
  const dataLayer = useDataLayer();
  const allo = useAllo();
  const navigate = useNavigate();
  const {
    switchChain
  } = useSwitchChain();
  const {
    data: projectData,
    error: projectError,
    isLoading: isProjectDataLoading
  } = useProject({
    projectId: projectId
  }, dataLayer);
  const {
    applications: projectApplications,
    error: projectApplicationsError,
    isLoading: isProjectApplicationsLoading
  } = useProjectApplications({
    projectId: projectId
  }, dataLayer);
  const {
    directAllocation,
    tokenApprovalStatus,
    fundStatus,
    indexingStatus,
    txHash
  } = useDirectAllocation();
  useMemo(() => {
    if (!address) return;
    const runner = async () => {
      const balances = await Promise.all(payoutTokenOptions.map(async token => {
        const {
          value
        } = await getBalance(config, {
          address: getAddress(address),
          token: token.address === zeroAddress || token.address.toLowerCase() === NATIVE.toLowerCase() ? undefined : token.address,
          chainId: chainId
        });
        return {
          token: token.address,
          balance: value / BigInt(getMultiplier(chainId))
        };
      }));
      setTokenBalances(balances);
    };
    if (address && address !== zeroAddress) runner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId, address]);
  const pastRroundApplications = projectApplications === null || projectApplications === void 0 ? void 0 : projectApplications.filter(projectApplication => new Date(projectApplication.round.donationsEndTime) < new Date());
  const project = projectData === null || projectData === void 0 ? void 0 : projectData.project;
  useEffect(() => {
    if (tokenApprovalStatus === ProgressStatus.IS_ERROR || fundStatus === ProgressStatus.IS_ERROR) {
      setTimeout(() => {
        setOpenProgressModal(false);
        setErrorModalSubHeading(transactionReplaced ? "Transaction cancelled. Please try again." : "There was an error during the funding process. Please try again.");
        setOpenErrorModal(true);
      }, errorModalDelayMs);
    }
    if (indexingStatus === ProgressStatus.IS_ERROR) {
      setTimeout(() => {
        // refresh
        navigate(0);
      }, 5000);
    }
    if (tokenApprovalStatus === ProgressStatus.IS_SUCCESS && fundStatus === ProgressStatus.IS_SUCCESS && txHash !== "") {
      setTimeout(() => {
        setOpenProgressModal(false);
        // refresh
        navigate(0);
      }, errorModalDelayMs);
    }
  }, [navigate, tokenApprovalStatus, fundStatus, indexingStatus, txHash, transactionReplaced, projectId]);
  const breadCrumbs = [{
    name: "Explorer Home",
    path: "/"
  }, {
    name: "Projects",
    path: `/projects`
  }, {
    name: project === null || project === void 0 ? void 0 : project.metadata.title,
    path: `/projects/${projectId}`
  }];
  const progressSteps = [{
    name: "Token Approval",
    description: "Approving token transfer.",
    status: tokenApprovalStatus
  }, {
    name: "Donating",
    description: "Donating to the project.",
    status: fundStatus
  }, {
    name: "Indexing",
    description: "Indexing the data.",
    status: indexingStatus
  }, {
    name: "Redirecting",
    description: "Just another moment while we finish things up.",
    status: indexingStatus === ProgressStatus.IS_SUCCESS ? ProgressStatus.IN_PROGRESS : ProgressStatus.NOT_STARTED
  }];
  const {
    metadata: {
      title,
      description = "",
      bannerImg
    }
  } = project !== null && project !== void 0 ? project : {
    metadata: {}
  };
  const projectDetailsTabs = useMemo(() => [{
    name: "Overview",
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h3", {
        className: "text-3xl mt-8 mb-4 font-modern-era-medium text-blue-800",
        children: "About"
      }), project ? /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Detail, {
          text: description,
          testID: "project-metadata"
        })
      }) : /*#__PURE__*/_jsx(SkeletonText, {})]
    })
  }, {
    name: "Past rounds",
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [isProjectApplicationsLoading && /*#__PURE__*/_jsx(SkeletonText, {}), projectApplicationsError && /*#__PURE__*/_jsx("p", {
        className: "ml-4 mt-8",
        children: "Couldn't load project data."
      }), pastRroundApplications && (pastRroundApplications === null || pastRroundApplications === void 0 ? void 0 : pastRroundApplications.length) > 0 && /*#__PURE__*/_jsx(_Fragment, {
        children: pastRroundApplications.map(projectApplication => /*#__PURE__*/_jsx(RoundListItem, {
          projectApplication: projectApplication
        }, projectApplication.id))
      }), pastRroundApplications && (pastRroundApplications === null || pastRroundApplications === void 0 ? void 0 : pastRroundApplications.length) === 0 && /*#__PURE__*/_jsx("p", {
        className: "ml-4 mt-8",
        children: "No past rounds found."
      })]
    })
  }], [project, description, isProjectApplicationsLoading, projectApplicationsError, pastRroundApplications]);
  const onSwitchNetwork = () => {
    if (switchChain && project !== null && project !== void 0 && project.chainId) {
      switchChain({
        chainId: project === null || project === void 0 ? void 0 : project.chainId
      });
      setHasNetworkSwitched(true);
    }
  };
  useEffect(() => {
    if (hasNetworkSwitched) {
      if (chainId === (project === null || project === void 0 ? void 0 : project.chainId)) {
        setShowSwitchNetworkModal(false);
        setShowDirectAllocationModal(true);
      }
    }
  }, [chainId, project === null || project === void 0 ? void 0 : project.chainId, hasNetworkSwitched]);
  const handleTabChange = tabIndex => {
    setSelectedTab(tabIndex);
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: projectData !== undefined || isProjectDataLoading ? /*#__PURE__*/_jsxs(DefaultLayout, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-row justify-between my-8",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex items-center pt-2",
          "data-testid": "bread-crumbs",
          children: /*#__PURE__*/_jsx(Breadcrumb, {
            items: breadCrumbs
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "mb-4",
        children: [/*#__PURE__*/_jsx(ProjectBanner, {
          bannerImgCid: bannerImg !== null && bannerImg !== void 0 ? bannerImg : null,
          classNameOverride: "h-32 w-full object-cover lg:h-80 rounded md:rounded-3xl",
          resizeHeight: 320
        }), /*#__PURE__*/_jsx("div", {
          className: "pl-4 sm:pl-6 lg:pl-8",
          children: /*#__PURE__*/_jsx("div", {
            className: "sm:flex sm:items-end sm:space-x-5",
            children: /*#__PURE__*/_jsx("div", {
              className: "flex",
              children: /*#__PURE__*/_jsx(ProjectLogo, {
                ...(project === null || project === void 0 ? void 0 : project.metadata)
              })
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "md:flex gap-4 flex-row-reverse",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-4",
          children: /*#__PURE__*/_jsx(Sidebar, {
            projectApplications: projectApplications,
            directAllocationPoolId: directAllocationPoolId,
            isConnected: isConnected,
            chainId: Number(chainId),
            project: project,
            setShowSwitchNetworkModal: setShowSwitchNetworkModal,
            setShowDirectAllocationModal: setShowDirectAllocationModal,
            openConnectModal: openConnectModal
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: projectError === undefined ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Skeleton, {
              isLoaded: projectData !== undefined && projectError === undefined,
              children: /*#__PURE__*/_jsx("h1", {
                className: "text-4xl font-modern-era-medium tracking-tight text-grey-500",
                children: title
              })
            }), /*#__PURE__*/_jsx(ProjectLinks, {
              project: project
            }), /*#__PURE__*/_jsx(ProjectDetailsTabs, {
              selected: selectedTab,
              onChange: handleTabChange,
              tabs: projectDetailsTabs.map(tab => tab.name)
            }), /*#__PURE__*/_jsx("div", {
              className: "[&_a]:underline",
              children: projectDetailsTabs[selectedTab].content
            })]
          }) : /*#__PURE__*/_jsx("p", {
            children: "Couldn't load project data."
          })
        }), /*#__PURE__*/_jsx(DonationModals, {})]
      })]
    }) : /*#__PURE__*/_jsx(NotFoundPage, {})
  });
  function DonationModals() {
    var _getChainById$name, _getChainById, _project$chainId;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SwitchNetworkModal, {
        networkName: (_getChainById$name = (_getChainById = getChainById((_project$chainId = project === null || project === void 0 ? void 0 : project.chainId) !== null && _project$chainId !== void 0 ? _project$chainId : 1)) === null || _getChainById === void 0 ? void 0 : _getChainById.name) !== null && _getChainById$name !== void 0 ? _getChainById$name : "",
        onSwitchNetwork: onSwitchNetwork,
        action: "donate to this project",
        isOpen: showSwitchNetworkModal,
        setIsOpen: setShowSwitchNetworkModal
      }), /*#__PURE__*/_jsx(GenericModal, {
        body: /*#__PURE__*/_jsx(DirectDonationModalComponent, {
          chainId: chainId,
          address: address,
          directDonationAmount: directDonationAmount,
          setDirectDonationAmount: setDirectDonationAmount,
          payoutToken: payoutToken,
          setPayoutToken: setPayoutToken,
          payoutTokenOptions: payoutTokenOptions,
          tokenBalances: tokenBalances,
          projectData: {
            project: project
          },
          handleDonate: handleDonate
        }),
        isOpen: showDirectAllocationModal,
        setIsOpen: setShowDirectAllocationModal
      }), /*#__PURE__*/_jsx(ProgressModal, {
        isOpen: openProgressModal,
        subheading: "Please hold while we donate your funds to the project.",
        steps: progressSteps
      }), /*#__PURE__*/_jsx(ErrorModal, {
        isOpen: openErrorModal,
        setIsOpen: setOpenErrorModal,
        onTryAgain: handleDonate,
        subheading: errorModalSubHeading
      })]
    });
  }
  async function handleDonate() {
    if (directDonationAmount === undefined || allo === null || payoutToken === undefined || directAllocationPoolId === undefined) {
      return;
    }
    setShowDirectAllocationModal(false);
    setOpenProgressModal(true);
    try {
      var _project$projectRoles;
      let requireTokenApproval = false;
      const poolId = directAllocationPoolId.toString();
      const recipient = project === null || project === void 0 || (_project$projectRoles = project.projectRoles) === null || _project$projectRoles === void 0 ? void 0 : _project$projectRoles.filter(role => role.role === "owner")[0].address;
      const nonce = project === null || project === void 0 ? void 0 : project.nonce;
      if (poolId === undefined || recipient === undefined || nonce === undefined) {
        console.error("handleDonation - project", projectId, "missing data");
        return;
      }
      if ((payoutToken === null || payoutToken === void 0 ? void 0 : payoutToken.address) !== undefined && (payoutToken === null || payoutToken === void 0 ? void 0 : payoutToken.address) !== zeroAddress) {
        requireTokenApproval = true;
      }
      await directAllocation({
        allo,
        poolId,
        fundAmount: Number(parseFloat(directDonationAmount).toFixed(payoutToken.decimals)),
        payoutToken,
        recipient,
        nonce,
        requireTokenApproval
      });
    } catch (error) {
      if (error === Logger.errors.TRANSACTION_REPLACED) {
        setTransactionReplaced(true);
      } else {
        console.error("handleDonation - project", projectId, error);
      }
    }
  }
}
export function DirectDonationModalComponent(props) {
  var _props$projectData, _props$projectData2, _props$projectData3;
  const [hasEnoughFunds, setHasEnoughFunds] = useState(false);
  useMemo(() => {
    var _props$tokenBalances$, _props$tokenBalances$2, _props$payoutToken$de, _props$payoutToken2;
    setHasEnoughFunds(Number(props.directDonationAmount) <= Number(ethers.utils.formatUnits((_props$tokenBalances$ = (_props$tokenBalances$2 = props.tokenBalances.find(balance => {
      var _props$payoutToken$ad, _props$payoutToken;
      return balance.token.toLowerCase() === ((_props$payoutToken$ad = (_props$payoutToken = props.payoutToken) === null || _props$payoutToken === void 0 ? void 0 : _props$payoutToken.address) !== null && _props$payoutToken$ad !== void 0 ? _props$payoutToken$ad : "").toLowerCase();
    })) === null || _props$tokenBalances$2 === void 0 ? void 0 : _props$tokenBalances$2.balance) !== null && _props$tokenBalances$ !== void 0 ? _props$tokenBalances$ : 0n, (_props$payoutToken$de = (_props$payoutToken2 = props.payoutToken) === null || _props$payoutToken2 === void 0 ? void 0 : _props$payoutToken2.decimals) !== null && _props$payoutToken$de !== void 0 ? _props$payoutToken$de : 18)));
  }, [props.directDonationAmount, props.tokenBalances, props.payoutToken]);
  const [hasClickedSubmit, setHasClickedSubmit] = useState(false);
  const [isEmptyInput, setIsEmptyInput] = useState(false);
  useEffect(() => {
    if (props.directDonationAmount === "" || Number(props.directDonationAmount) === 0) {
      setIsEmptyInput(true);
    } else {
      setIsEmptyInput(false);
    }
  }, [props.directDonationAmount]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("p", {
        className: "mb-4 text-lg font-bold",
        children: [/*#__PURE__*/_jsx(BoltIcon, {
          className: "w-4 h-4 mb-1 inline-block mr-2"
        }), "Direct Donation"]
      }), /*#__PURE__*/_jsx("p", {
        className: "mb-2",
        children: "This is a direct donation to the project. Please note that as the donation is outside of a quadratic funding round it doesn't receive any matching funds."
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "mb-4 flex flex-col lg:flex-row justify-between sm:px-2 px-2 py-4 rounded-md",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex relative overflow-hidden bg-no-repeat bg-cover mt-auto mb-auto",
          children: [/*#__PURE__*/_jsx("img", {
            className: "inline-block rounded-full w-10 my-auto mr-2",
            src: (_props$projectData = props.projectData) !== null && _props$projectData !== void 0 && _props$projectData.project.metadata.logoImg ? `${ipfsGateway}/ipfs/${(_props$projectData2 = props.projectData) === null || _props$projectData2 === void 0 ? void 0 : _props$projectData2.project.metadata.logoImg}` : DefaultLogoImage,
            alt: "Project Logo"
          }), /*#__PURE__*/_jsx("p", {
            className: "font-semibold text-md my-auto text-ellipsis line-clamp-1 max-w-[100px]",
            children: (_props$projectData3 = props.projectData) === null || _props$projectData3 === void 0 || (_props$projectData3 = _props$projectData3.project) === null || _props$projectData3 === void 0 ? void 0 : _props$projectData3.metadata.title
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex sm:space-x-4 space-x-2 h-16 sm:pl-4 pt-3 justify-center",
        children: [/*#__PURE__*/_jsx("p", {
          className: "mt-4 md:mt-3 text-xs md:text-sm amount-text font-medium",
          children: "Amount"
        }), /*#__PURE__*/_jsx(Input, {
          "aria-label": "Donation amount for all projects ",
          id: "input-donationamount",
          min: "0",
          type: "text",
          value: props.directDonationAmount,
          onChange: e => {
            const value = e.target.value.replace(",", ".");
            if (/^\d*\.?\d*$/.test(value) || value === "") {
              props.setDirectDonationAmount(value);
            }
          },
          className: "w-16 lg:w-18"
        }), /*#__PURE__*/_jsx(PayoutTokenDropdown, {
          selectedPayoutToken: props.payoutToken,
          setSelectedPayoutToken: token => {
            props.setPayoutToken(token);
          },
          payoutTokenOptions: props.payoutTokenOptions,
          style: "max-h-16",
          balanceWarning: false
        })]
      })]
    }), isEmptyInput && hasClickedSubmit && /*#__PURE__*/_jsxs("p", {
      "data-testid": "emptyInput",
      className: "rounded-md bg-red-50 py-2 text-pink-500 flex justify-center my-4 text-sm",
      children: [/*#__PURE__*/_jsx(InformationCircleIcon, {
        className: "w-4 h-4 mr-1 mt-0.5"
      }), /*#__PURE__*/_jsx("span", {
        children: "You must enter donation for the project"
      })]
    }), !hasEnoughFunds && /*#__PURE__*/_jsxs("p", {
      "data-testid": "hasEnoughFunds",
      className: "rounded-md bg-red-50 py-2 text-pink-500 flex justify-center my-4 text-sm",
      children: [/*#__PURE__*/_jsx(InformationCircleIcon, {
        className: "w-4 h-4 mr-1 mt-0.5"
      }), /*#__PURE__*/_jsx("span", {
        children: "You don't have enough funds"
      })]
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "w-full font-normal rounded-lg bg-gitcoin-violet-400 text-white focus-visible:outline-indigo-600 py-2 leading-6",
      onClick: () => {
        if (isEmptyInput) {
          setHasClickedSubmit(true);
          return;
        }
        props.handleDonate();
      },
      disabled: !hasEnoughFunds,
      children: "Submit your donation"
    })]
  });
}
function ProjectDetailsTabs(props) {
  return /*#__PURE__*/_jsx(Box, {
    className: "",
    bottom: 0.5,
    children: props.tabs.length > 0 && /*#__PURE__*/_jsx(Tabs, {
      display: "flex",
      onChange: props.onChange,
      defaultIndex: props.selected,
      children: props.tabs.map((tab, index) => /*#__PURE__*/_jsx(Tab, {
        children: tab
      }, index))
    })
  });
}
function ProjectLinks(_ref) {
  let {
    project
  } = _ref;
  const {
    metadata: {
      createdAt,
      updatedAt,
      website,
      projectTwitter,
      projectGithub,
      userGithub,
      credentials
    }
  } = project !== null && project !== void 0 ? project : {
    metadata: {}
  };
  const {
    isValid: validTwitterCredential
  } = useValidateCredential(credentials === null || credentials === void 0 ? void 0 : credentials.twitter, projectTwitter);
  const {
    isValid: validGithubCredential
  } = useValidateCredential(credentials === null || credentials === void 0 ? void 0 : credentials.github, projectGithub);
  const createdOn = createdAt && `Created on: ${formatDateWithOrdinal(new Date(createdAt !== null && createdAt !== void 0 ? createdAt : 0))}`;
  const updatedOn = updatedAt && `Last edited: ${formatDateWithOrdinal(new Date(updatedAt !== null && updatedAt !== void 0 ? updatedAt : 0))}`;
  return /*#__PURE__*/_jsxs("div", {
    className: `grid md:grid-cols-2 gap-4  border-y-[2px] py-4 my-4 ${
    // isLoading?
    createdAt ? "" : "bg-grey-100 animate-pulse"}`,
    children: [/*#__PURE__*/_jsx(ProjectLink, {
      url: website,
      icon: GlobeIcon,
      children: website
    }), /*#__PURE__*/_jsx(ProjectLink, {
      icon: CalendarIcon,
      children: createdOn
    }), projectTwitter !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://twitter.com/${projectTwitter}`,
      icon: TwitterIcon,
      isVerified: validTwitterCredential,
      children: projectTwitter
    }), /*#__PURE__*/_jsx(ProjectLink, {
      icon: CalendarIcon,
      children: updatedOn
    }), projectGithub !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://github.com/${projectGithub}`,
      icon: GithubIcon,
      isVerified: validGithubCredential,
      children: projectGithub
    }), userGithub !== undefined && /*#__PURE__*/_jsx(ProjectLink, {
      url: `https://github.com/${userGithub}`,
      icon: GithubIcon,
      children: userGithub
    })]
  });
}
function ProjectLink(_ref2) {
  let {
    icon,
    children,
    url,
    isVerified
  } = _ref2;
  return children ? /*#__PURE__*/_jsxs("div", {
    className: "flex items-center gap-2",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/createElement(icon, {
        className: "w-4 h-4 text-grey-400"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex gap-2",
      children: [url ? /*#__PURE__*/_jsx("a", {
        href: url,
        target: "_blank",
        className: "text-blue-300 hover:underline",
        children: children
      }) : /*#__PURE__*/_jsx("div", {
        className: "text-blue-300 hover:underline",
        children: children
      }), isVerified && /*#__PURE__*/_jsx(VerifiedBadge, {})]
    })]
  }) : null;
}
function VerifiedBadge() {
  return /*#__PURE__*/_jsxs("span", {
    className: "bg-teal-100 flex gap-2 rounded-full px-2 text-xs items-center font-modern-era-medium text-teal-500",
    children: [/*#__PURE__*/_jsx(ShieldCheckIcon, {
      className: "w-4 h-4"
    }), "Verified"]
  });
}
function Detail(props) {
  return /*#__PURE__*/_jsx("p", {
    dangerouslySetInnerHTML: {
      __html: renderToHTML(props.text.replace(/\n/g, "\n\n"))
    },
    className: "text-blue-800 text-md prose prose-h1:text-lg prose-h2:text-base prose-h3:text-base prose-a:text-blue-600 max-w-full",
    "data-testid": props.testID
  });
}
const ipfsGateway = process.env.REACT_APP_IPFS_BASE_URL;
function ProjectLogo(_ref3) {
  let {
    logoImg
  } = _ref3;
  const src = logoImg ? `${ipfsGateway}/ipfs/${logoImg}` : DefaultLogoImage;
  return /*#__PURE__*/_jsx("img", {
    className: "-mt-16 h-32 w-32 rounded-full ring-4 ring-white bg-white",
    src: src,
    alt: "Project Logo"
  });
}
function Sidebar(props) {
  var _props$projectApplica;
  const activeQFRoundApplications = (_props$projectApplica = props.projectApplications) === null || _props$projectApplica === void 0 ? void 0 : _props$projectApplica.filter(projectApplication => new Date(projectApplication.round.donationsEndTime) > new Date() && projectApplication.round.strategyName === "allov2.DonationVotingMerkleDistributionDirectTransferStrategy");
  const {
    projects,
    add,
    remove
  } = useCartStorage();
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/_jsx("div", {
      className: "min-w-[320px] h-fit mb-6 rounded-3xl bg-gray-50",
      children: /*#__PURE__*/_jsx(ProjectStats, {
        projectApplications: props.projectApplications
      })
    }), props.directAllocationPoolId && /*#__PURE__*/_jsxs("button", {
      type: "button",
      "data-testid": "direct-allocation-button",
      className: "w-full block mb-8 mx-1 bg-gitcoin-violet-100 py-2 text-center text-sm font-semibold rounded-lg leading-6 text-gitcoin-violet-400 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
      onClick: () => {
        var _props$project, _props$project2;
        if (!props.isConnected) {
          var _props$openConnectMod;
          (_props$openConnectMod = props.openConnectModal) === null || _props$openConnectMod === void 0 || _props$openConnectMod.call(props);
          return;
        }
        if (((_props$project = props.project) === null || _props$project === void 0 ? void 0 : _props$project.chainId) === undefined) {
          console.error("project chainId is undefined");
          return;
        }
        if (props.chainId !== ((_props$project2 = props.project) === null || _props$project2 === void 0 ? void 0 : _props$project2.chainId)) {
          props.setShowSwitchNetworkModal(true);
        } else {
          props.setShowDirectAllocationModal(true);
        }
      },
      children: [/*#__PURE__*/_jsx(BoltIcon, {
        className: "w-4 h-4 inline-block mr-1 mb-1"
      }), "Donate"]
    }), activeQFRoundApplications && (activeQFRoundApplications === null || activeQFRoundApplications === void 0 ? void 0 : activeQFRoundApplications.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h4", {
        className: "text-xl font-medium",
        children: "Active rounds"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-md mt-2 text-gray-500 max-w-[320px]",
        children: "The project is currently participating in the below active rounds. Donating to the project in these rounds will help it receive matching funds."
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 max-w-[320px] h-fit rounded-3xl ",
      children: activeQFRoundApplications === null || activeQFRoundApplications === void 0 ? void 0 : activeQFRoundApplications.map(projectApplication => /*#__PURE__*/_jsx(ActiveRoundComponent, {
        projectApplication: projectApplication,
        addToCart: add,
        removeFromCart: remove,
        projectsInCart: projects
      }, projectApplication.id))
    })]
  });
}
export function ProjectStats(props) {
  var _props$projectApplica2, _props$projectApplica3, _props$projectApplica4, _props$projectApplica5, _props$projectApplica6, _props$projectApplica7, _props$projectApplica8, _props$projectApplica9;
  const totalFundingReceived = (_props$projectApplica2 = (_props$projectApplica3 = props.projectApplications) === null || _props$projectApplica3 === void 0 ? void 0 : _props$projectApplica3.reduce((acc, projectApplication) => acc + projectApplication.totalAmountDonatedInUsd, 0).toFixed()) !== null && _props$projectApplica2 !== void 0 ? _props$projectApplica2 : "0";
  const totalContributions = (_props$projectApplica4 = (_props$projectApplica5 = props.projectApplications) === null || _props$projectApplica5 === void 0 ? void 0 : _props$projectApplica5.reduce((acc, projectApplication) => acc + projectApplication.totalDonationsCount, 0).toFixed()) !== null && _props$projectApplica4 !== void 0 ? _props$projectApplica4 : "0";
  const totalUniqueDonors = (_props$projectApplica6 = (_props$projectApplica7 = props.projectApplications) === null || _props$projectApplica7 === void 0 ? void 0 : _props$projectApplica7.reduce((acc, projectApplication) => acc + projectApplication.uniqueDonorsCount, 0).toFixed()) !== null && _props$projectApplica6 !== void 0 ? _props$projectApplica6 : "0";
  const totalRoundsParticipated = (_props$projectApplica8 = (_props$projectApplica9 = props.projectApplications) === null || _props$projectApplica9 === void 0 ? void 0 : _props$projectApplica9.length) !== null && _props$projectApplica8 !== void 0 ? _props$projectApplica8 : 0;
  return /*#__PURE__*/_jsx("div", {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsxs("div", {
      className: "rounded-3xl flex-auto p-3 md:p-4 gap-4 flex flex-col text-blue-800",
      children: [/*#__PURE__*/_jsx("h4", {
        className: "text-2xl",
        children: "All-time stats"
      }), /*#__PURE__*/_jsx(Stat, {
        isLoading: false,
        value: `$${totalFundingReceived}`,
        children: "funding received"
      }), /*#__PURE__*/_jsx(Stat, {
        isLoading: false,
        value: totalContributions,
        children: "contributions"
      }), /*#__PURE__*/_jsx(Stat, {
        isLoading: false,
        value: totalUniqueDonors,
        children: "unique contributors"
      }), /*#__PURE__*/_jsx(Stat, {
        isLoading: false,
        value: totalRoundsParticipated,
        children: "rounds participated"
      })]
    })
  });
}
export function Stat(_ref4) {
  let {
    value,
    children,
    isLoading,
    className
  } = _ref4;
  return /*#__PURE__*/_jsxs("div", {
    className: `flex flex-col ${className}`,
    children: [/*#__PURE__*/_jsx(Skeleton, {
      isLoaded: !isLoading,
      height: "36px",
      children: /*#__PURE__*/_jsx("h4", {
        className: "text-3xl",
        children: value
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "text-sm md:text-base",
      children: children
    })]
  });
}
export function RoundListItem(_ref5) {
  let {
    projectApplication
  } = _ref5;
  const applicationsStartTime = new Date(projectApplication.round.applicationsStartTime).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  const donationsEndTime = new Date(projectApplication.round.donationsEndTime).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  const roundType = projectApplication.round.strategyName === "allov1.Direct" || projectApplication.round.strategyName === "allov2.DirectGrantsSimpleStrategy" || projectApplication.round.strategyName === "allov2.DirectGrantsLiteStrategy" ? "Direct grants" : "Quadratic funding";
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full my-8 flex flex-col md:flex-row justify-between items-center text-sm px-2 border-b border-gray-400",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex md:flex-auto my-2 md:w-24 truncate mr-4",
      children: /*#__PURE__*/_jsx("span", {
        className: "text-black-400 font-semibold",
        children: projectApplication.round.project.name
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "flex md:flex-auto my-2 md:w-24 truncate mr-4",
      children: /*#__PURE__*/_jsx("span", {
        className: "text-black-400 font-semibold",
        children: projectApplication.round.roundMetadata.name
      })
    }), roundType === "Quadratic funding" ? /*#__PURE__*/_jsx("div", {
      className: "flex-1 my-2 mr-4 text-gray-500",
      children: /*#__PURE__*/_jsxs("span", {
        children: [applicationsStartTime, " - ", donationsEndTime]
      })
    }) : /*#__PURE__*/_jsx("div", {
      className: "flex-1 my-2 mr-4 text-gray-500",
      children: /*#__PURE__*/_jsx("span", {
        children: applicationsStartTime
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-1 my-2",
      children: /*#__PURE__*/_jsx("span", {
        className: `flex justify-center ${roundType === "Quadratic funding" ? "bg-green-100" : "bg-yellow-100"} items-center text-md rounded-full p-2 font-medium`,
        children: /*#__PURE__*/_jsx("span", {
          className: "text-black font-medium",
          children: roundType
        })
      })
    })]
  });
}
export function ActiveRoundComponent(props) {
  const roundName = props.projectApplication.round.roundMetadata.name;
  const roundStartDate = new Date(props.projectApplication.round.donationsStartTime).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  const roundEndDate = new Date(props.projectApplication.round.donationsEndTime).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  const cartProject = {
    grantApplicationId: props.projectApplication.id,
    projectRegistryId: props.projectApplication.projectId,
    anchorAddress: props.projectApplication.anchorAddress,
    recipient: props.projectApplication.metadata.application.recipient,
    projectMetadata: props.projectApplication.metadata.application.project,
    grantApplicationFormAnswers: [],
    status: props.projectApplication.status,
    applicationIndex: Number(props.projectApplication.id),
    roundId: props.projectApplication.roundId,
    chainId: props.projectApplication.chainId,
    amount: "0"
  };
  const roundLink = `https://explorer.gitcoin.co/#/round/${props.projectApplication.chainId}/${props.projectApplication.roundId}`;
  const roundChain = getChainById(props.projectApplication.chainId);
  const isProjectInCart = props.projectsInCart.some(project => project.projectRegistryId === cartProject.projectRegistryId);
  return /*#__PURE__*/_jsxs("div", {
    className: "p-4 bg-gray-50 rounded-3xl flex flex-col space-y-4",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex justify-between items-center",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "text-lg font-semibold text-gray-900 mb-2",
          children: roundName
        }), /*#__PURE__*/_jsxs("div", {
          className: "text-gray-500mb-4",
          children: [roundStartDate, " - ", roundEndDate]
        })]
      }), /*#__PURE__*/_jsx("img", {
        className: "mt-2 ml-2 inline-block h-9 w-9",
        src: stringToBlobUrl(roundChain.icon),
        alt: "Chain Logo"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex justify-between gap-2",
      children: [/*#__PURE__*/_jsx("a", {
        href: roundLink,
        target: "_blank",
        className: "flex justify-center bg-green-100 text-black-500 rounded-xl px-4 py-2 w-3/4",
        children: "View round"
      }), isProjectInCart ? /*#__PURE__*/_jsx("div", {
        onClick: () => props.removeFromCart(cartProject),
        className: "flex text-black-500 w-1/4 justify-center cursor-pointer",
        children: /*#__PURE__*/_jsx(CheckedCircleIcon, {
          className: "w-10"
        })
      }) : /*#__PURE__*/_jsx("div", {
        onClick: () => props.addToCart(cartProject),
        className: "flex text-black-500 w-1/4 justify-center cursor-pointer",
        children: /*#__PURE__*/_jsx(CartCircleIcon, {
          className: "w-10"
        })
      })]
    })]
  });
}